import React, { CSSProperties } from 'react';
import { ICTA, IEHSImage } from 'utils/types';
import * as S from './styles';

export interface IImageCard {
  heading: string;
  type?: string;
  headingStyles?: CSSProperties;
  contentStyles?: CSSProperties;
  content: string;
  image?: IEHSImage;
  cta?: ICTA;
  className?: string;
}

export const ImageCard: React.FC<IImageCard> = ({
  heading,
  headingStyles,
  contentStyles,
  content,
  image,
  cta,
  type,
  className,
}) => (
  <S.ImageCard className={className}>
    {image ? <S.Image image={image.gatsbyImageData} alt={image.title} /> : null}
    <S.CardContent>
      {type ? <S.Type>{type}</S.Type> : null}
      <S.ContentWrapper style={contentStyles}>
        <S.Heading style={headingStyles}>{heading}</S.Heading>
        <S.Content>{content}</S.Content>
      </S.ContentWrapper>
      {cta ? (
        <S.CTA href={cta.url} target="_self">
          {cta?.text}
        </S.CTA>
      ) : null}
    </S.CardContent>
  </S.ImageCard>
);

export default ImageCard;
